'use client';

import { useEffect } from 'react';
import { clarityIdentifyUser } from '@/lib/clarity';

const getAuthUser = () => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|; )authUser=([^;]*)/);
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
};

export function ClarityTracker() {
  useEffect(() => {
    const identify = () => {
      const user = getAuthUser();
      clarityIdentifyUser(user);
    };

    identify();
  }, []);

  return null;
}
